import { ApiOrderTemplate, ApiOrderTemplateService } from "./interface.api";

import { OrderTemplate, OrderTemplateService } from "@/types";

export const mapApiOrderTemplate = (api: ApiOrderTemplate): OrderTemplate => {
  return {
    customerId: api.CustomerId,
    dea: api.DEA,
    description: api.Description,
    floorAreaSurchargeAmount: api.FloorAreaSurchargeAmount,
    floorAreaSurchargeThreshold: api.FloorAreaSurchargeThreshold,
    hip: api.HIP,
    id: api.OrderTemplateId || 0,
    isVirtual: api.IsVirtual,
    orderOfferPrice: api.OrderOfferPrice,
    price: api.PriceExVAT,
    services: api.Services.reduce((acc: OrderTemplateService[], cur) => {
      return [
        ...acc,
        {
          checked: cur.Checked,
          // checkedTxt: cur.CheckedTxt,
          defaultAmount: cur.DefaultAmount,
          imageUrl: cur.ImageURL,
          name: cur.Name,
          orderTypeId: cur.OrderTypeId,
        }
      ]
    }, []),
    virtualTourImagesSurchargeAmount: api.VirtualTourImagesSurchargeAmount,
    virtualTourImagesThreshold: api.VirtualTourImagesThreshold
  }
}

export const mapApiOrderTemplates = (api: ApiOrderTemplate[]): OrderTemplate[] => {
  return api.map((orderTemplate) => mapApiOrderTemplate(orderTemplate));
}

export const mapOrderTemplate = (orderTemplate: OrderTemplate) : ApiOrderTemplate => {
  return {
    CustomerId: orderTemplate.customerId,
    Description: orderTemplate.description,
    FloorAreaSurchargeAmount: orderTemplate.floorAreaSurchargeAmount,
    FloorAreaSurchargeThreshold: orderTemplate.floorAreaSurchargeThreshold,
    IsVirtual: orderTemplate.isVirtual,
    OrderTemplateId: orderTemplate.id === 0 ? null : orderTemplate.id,
    PriceExVAT: orderTemplate.price,
    Services: orderTemplate.services.reduce((acc: ApiOrderTemplateService[], cur) => {
      return [
        ...acc,
        {
          Checked: cur.checked ?? false,
          CheckedTxt: '',
          DefaultAmount: cur.defaultAmount,
          ImageURL: cur.imageUrl,
          Name: cur.name,
          OrderTypeId: cur.orderTypeId,
        }
      ]
    }, []),
    VirtualTourImagesSurchargeAmount: orderTemplate.virtualTourImagesSurchargeAmount,
    VirtualTourImagesThreshold: orderTemplate.virtualTourImagesThreshold
  };
}